'use client';

import GeneralLayout from '@/layouts/General';
import Link from 'next/link';
import React from 'react';

const error = () => {
  return (
    <GeneralLayout>
      <div className="flex flex-col justify-center items-center text-center space-y-4 my-20">
        <p className="text-xl font-semibold">Something went wrong...</p>
        <Link className="button-filled" href="/">
          Go back to Home
        </Link>
      </div>
    </GeneralLayout>
  );
};

export default error;
